import { map } from "./map"
import { ordered_object } from "./ordered_object"

export const object_map = (keyf, valuef, iterable) =>
  ordered_object(
    map((value, key) => [keyf(value, key), valuef(value, key)], iterable)
  )
